import { UserRole } from "../pages/users/interfaces";
import { isArray } from "util";
import jMoment from "moment-jalaali";

export type OrderTransportationType =
  | "NONE"
  | "LINK_EXPRESS"
  | "ALOPEYK"
  | "TAROFF"
  | "TAROFF_V2"
  | "CHAPAR"
  | "PETROEX"
  | "TAPIN_POST"
  | "TAPIN_KETAB"
  | "NEDEX"
  | "SNAPP_BOX";

enum dictionaryKey {
  common,
  order,
  TPL,
  tplStatus,
  driver,
  service,
  parcel,
  insurance,
  inventory,
  bundle,
  fleet,
  user,
  center,
  ticket,
  cod,
  postPaid,
}

type dictionaryKeyStrings = keyof typeof dictionaryKey;
const dictionary = {
  common: {
    WEEKLY: "هفتگی",
    MONTHLY: "ماهانه",
    DAILY: "روزانه",
    YEARLY: "سالانه",
    BOX: "کارتن",
    PALLET: "پالت",
    BULK: "فله",
    CHARGE: "شارژ",
    INCREASE: "افزایش",
    DECREASE: "کاهش",
    SETTLE: "تسویه",
    UPDATE_ORDER_STATUS: "سرویس تغییر وضعیت سفارش",
    UPDATE_PARCEL_STATUS: "سرویس تغییر وضعیت محموله",
    COURIER: "پیک",
    POST: "پست",
    EXPRESS_POST: "پست پیشتاز",
    SPECIAL_POST: "پست سفارشی",
    VIP: "ارسال ویژه",
    PART_TIME: "پاره وقت",
    FULL_TIME: "تمام وقت",
    CAR: "سواری",
    MOTORCYCLE: "موتوری",
    PICKUPS: "وانت",
    TRUCK: "خاور",
    HEAVY_TRUCK: "کامیون",
    AIRPLANE: "هواپیما",
    "CHAPAR,COURIER": "هردو",
    CHAPAR: "چاپار",
    DELIVER_IN_RONAD: "تحویل در انبار",
  },
  order: {
    GOLDASTE: "گل دسته",
    RONAD: "روناد",
    ARRIVED: "به مقصد رسیده",
    BUNDLED: " بسته‌بندی شده برای راننده",
    CANCELLED: "لغو شده",
    DELIVERED_TO_POST: "ارسال به پست",
    DELIVERING_TO_POST: "در حال ارسال به پست",
    DELIVERED_TO_CENTER: "تحویل به مرکز",
    SUPPLIED_IN_CENTER: "تامین در مرکز",
    DELIVERED_TO_COURIER: "تحویل پیک شد",
    PACKAGED: "بسته بندی شده برای مشتری",
    PICKED: "برداشته شده",
    DELIVERED: "تحویل به مشتری",
    LOADED: "در حال تحویل",
    NOT_DELIVERED: "تحویل داده نشده",
    PROCESSING: "در حال پردازش",
    PROCESSED: "پردازش شده",
    ORDERED: "ایجاد شده",
    RETURNED: "بازگردانده شده",
    ASSIGNED: "تخصیص شده",
    REGISTERED_IN_3PL: "ثبت در 3PL",
    REGISTERING_IN_3PL: "درحال ثبت 3PL",
    DELIVERING: "درحال تحویل",
    DELIVERED_TO_3PL: "تحویل 3PL",
    DELIVERED_TO_3PL_COURIER: "تحویل پیک 3PL",
    CANCELED_FROM_3PL: "لغو از 3PL",
    AWAITING_REVIEW: "نا مشخص",
    SUPPLYING: "در انتظار تامین موجودی",
    DONE: "ارسال به پست",
    QUEUE: "آماده ارسال",
    DRAFT: "ارسال نشده",
    true: "باندل شده",
    false: "باندل نشده",
    REQUESTED_TO_RETURN: "درخواست بازگشت به انبار",
    RETURNED_TO_WAREHOUSE: "بازگشت به انبار",
    REQUESTED_TO_RESEND: "درخواست ارسال مجدد",
    SCANNED: "اسکن شده",
    CONFIRMED: "تایید شده",
    REGISTERED: "ثبت در سیستم",
    AWAITING_PAYMENT: "در انتظار پرداخت",
    CANCELED: "کنسل شده",
    FROM_CENTER: "مرکز توزیع به مشتری",
    WITHOUT_CENTER: "انبار به مشتری",
    "09:00:00": "صبح",
    "15:00:00": "بعدازظهر",
  },
  TPL: {
    NONE: "بدون 3PL",
    ALOPEYK: "الوپیک",
    LINK_EXPRESS: "لینک اکسپرس",
    TAROFF: "تعارف",
    TAROFF_V2: "تعارف",
    CHAPAR: "چاپار",
    PETROEX: "پتروکس",
    PISHRO_POST: "پیشرو پست",
    SPEED: "اسپید",
    DTSXP: "دی تی اس",
    TAPIN_POST: "تاپین",
    TAPIN_KETAB: "تاپین کتاب",
    NEDEX: "ندکس",
    RONAD: "لجستیک",
    SNAPP: "اسنپ",
    TAPSI: "تپسی",
    KHANOOMI: "خانومی",
    SNAPP_BOX: "اسنپ باکس",
    ALOPEYK_BUSINESS: "الوپیک بیزینس",
    TIPAX: "تیپاکس",
    PARTNER_LOGISTIC: "ناوگان مشتری",
    RONAD_LOGISTIC: "ناوگان روناد",
  },
  ticket: {
    OPEN: " باز",
    CLOSED: "بسته",
    ATTENDEE_ANSWERED: "پاسخ داده شد",
    ASSIGNEE_ANSWERED: "پاسخ داده شد",
    PENDING: "در انتظار پاسخ",
    OWNER_ANSWERED: "پاسخ ایجادکننده",
    NON: "ناشناخته",
    SUPPORT_OPEN: "ایجاد شده",
    SUPPORT_PENDING: "درحال بررسی",
    SUPPORT_ASSIGNEE_ANSWERED: "پاسخ داده شده",
    SUPPORT_OWNER_ANSWERED: "درحال بررسی",
    FFC_PENDING: "نیازمند بررسی",
    FFC_OPEN: "نیازمند بررسی",
    PARTNER_PENDING: "درحال بررسی",
    PARTNER_OPEN: "درحال بررسی",
    PARTNER_ASSIGNEE_ANSWERED: "درحال بررسی",
    FFC_ASSIGNEE_ANSWERED: "نیازمند بررسی",
    FFC_OWNER_ANSWERED: "نیازمند بررسی",
    PARTNER_OWNER_ANSWERED: "نیازمند بررسی",
    PARTNER_CLOSED: "بسته شده",
    SUPPORT_CLOSED: "بسته شده",
    FFC_CLOSED: "بسته شده",
    LOW: "کم",
    NORMAL: "متوسط",
    HIGH: "زیاد",
    CRITICAL: "اضطراری",
  },
  tplStatus: {
    REJECTED_BY_3PL: "رد شده توسط 3PL",
    REGISTERED_IN_3PL: "ثبت شده در 3PL",
    SEARCHING_COURIER: "جستجوی پیک",
    SEARCHING_COURIER_EXPIRED: "جستجوی پیک منقضی شد",
    COURIER_ACCEPTED: "پیک درخواست شما را پذیرفت",
    DELIVERED_TO_3PL: "تحویل داده شده به 3PL ",
    DELIVERED_TO_3PL_COURIER: "تحویل داده شده به پیک 3PL ",
    DELIVERED: "تحویل داده شده",
    NOT_DELIVERED: "تحویل داده نشده",
    CANCELLED: "لغو شده",
    REQUESTED_TO_CANCEL: "درخواست شده برای لغو",
    NOT_REGISTERED: "ایجاد شده (رجیستر نشده)",
    NONE: "هیچکدام",
  },
  driver: {
    REGISTERED: "ثبت نام",
    OFF: "غیر فعال",
    ACTIVE: "فعال",
    SUSPENDED: "معلق",
    DELIVERED: "سفیر شما رسیده است",
    PICKING: "در مسیر تحویل گرفتن سفارش",
    SEARCHING: "در حال جست و جوی سفیر",
    ACCEPTED: "سفیر شما تحویل بسته را پذیرفت",
    EXPIRED: "درخواست سفیر ، منقضی شد",
    DELIVERING: "بسته شما در مسیر تحویل دادن سفارش است",
    CANCELLED: "سفر شما لغو شد",
    ENTERED: "به مرکز رسیده",
    WAITING: "در انتظار بارگیری",
    LOADED: "بارگیری شده",
    EXITED: "خارج شده",
    pSUSPENDED: "معلق",
    pDELIVERED: "سفیر شما رسیده است",
    pPICKING: "در مسیر تحویل گرفتن سفارش",
    pSEARCHING: "در حال جست و جوی سفیر",
    pACCEPTED: "سفیر شما تحویل بسته را پذیرفت",
    pEXPIRED: "درخواست سفیر ، منقضی شد",
    pDELIVERING: "بسته شما در مسیر تحویل دادن سفارش است",
    pCANCELLED: "سفر شما لغو شد",
    pENTERED: "به مرکز رسیده",
    pWAITING: "در انتظار تخلیه",
    pLOADED: "تخلیه شده",
    pEXITED: "خارج شده",
  },
  service: {
    1: "پیشتاز",
    2: "سفارشی",
    3: "ویژه",
  },
  parcel: {
    1: "پاکت پیشتاز",
    2: "بسته پیشتاز",
    3: "پاکت سفارشی",
    4: "بسته سفارشی",
    5: "مطبوع",
    6: "کیسه M",
    10: "امانت",
    SUBMITTED: "ایجاد شده",
    SHIPPED: " ارسال شده",
    DELIVERED: " تخلیه شده",
    CANCELLED: " لغو شده",
    ASSIGNED: "اختصاص داده شده",
    RETURNING: "ریجکت شده",
    ARRIVED: "به مقصد رسیده",
    UNLOADING: "در حال بارگذاری",
    UNLOADED: "تخلیه شده",
    CONFLICTED: "مغایرت",
    REGISTERED: "رجیستر شده",
    LOCATED: "جایگذاری شده",
    PICKED: "برداشته شده",
    NOT_REGISTERED: "ایجاد شده (رجیستر نشده)",
    CHECKED: "بسته‌بندی شده",
    MONTHLY_ECONOMIC_PICKUP: "سراسری ماهانه",
    WEEKLY_ECONOMIC_PICKUP: "هفتگی تهران",
  },
  insurance: {
    1: "بیمه عادی",
    2: "وجه نقد",
    3: "اوراق و اسناد بانکی",
    4: "بار انبوه",
    5: "سایر",
  },
  inventory: {
    FROZEN: "منجمد",
    FRUIT: "میوه",
    GROCERY: "خواربار",
    MEAT: "گوشت",
    MASK: "ماسک",
    PRODUCT: "محصول",
    PICKED: "برداشته شده",
    CHECKED: "بررسی شده",
    NOT_REGISTERED: "ایجاد شده (رجیستر نشده)",
    REGISTERED: "رجیستر شده",
    LOCATED: "جایگذاری شده",
    NOT_LOCATED: "جاگذاری نشده",
    INBOUND: "ورودی",
    PURCHASE: "سفارش",
    OUTBOUND: "خروجی",
    CURRENTLY: "موجودی فعلی",
    OTHER: "نامشخص",
    null: "نامشخص",
  },
  bundle: {
    ASSIGNED: "اختصاص داده شده",
    CANCELLED: "لغو شده",
    CREATED: "بسته ایجاد شده",
    LOADED: "بارگیری شده",
    PROCESS_FAILED: "ناموفق",
    PROCESS_STARTED: "راننده در مسیر مرکز",
    PROCESSED: "راننده تحویل داده",
    VEHICLE_ARRIVED: "ماشین به مرکز رسیده",
  },
  fleet: {
    PROPRIETARY: "اختصاصی",
    THIRD_PARTY: "عمومی",
    SUSPENDED: "غیر فعال",
    ACTIVE: "فعال",
  },
  user: {
    NONE: "هیچکدام",
    RONAD_ADMIN: "مدیر ارشد",
    PARTNER_ADMIN: "ادمین شرکت",
    LOGISTICS_ADMIN: "سرپرست لجستیک",
    WAREHOUSE_ADMIN: "ادمین انبار",
    WAREHOUSE_OPERATOR: "اپراتور انبار",
    WAREHOUSE_SUPERVISOR: "سرپرست انبار",
    DRIVER: "راننده",
    CENTER_ADMIN: "ادمین مرکز",
    MARKETING_MANAGER: "مدیر مارکتینگ",
    MARKETING_EXPERT: "کارشناس مارکتینگ",
    OPERATIONS_MANAGER: "مدیر عملیات",
    OPERATIONS_EXPERT: "کارشناس عملیات",
    SUPPORT_MANAGER: "مدیر پشتیبانی",
    SUPPORT_EXPERT: "کارشناس پشتیبانی",
    AGENCY_ADMIN: "نماینده",
    SELLER_ADMIN: "ادمین فروشنده",
    FINANCIAL_SUPERVISOR: "سرپرست مالی",
  },
  center: {
    ACTIVE: "فعال",
    SUSPENDED: "غیرفعال",
  },
  cod: {
    COD: "در محل",
    ONLINE: "آنلاین",
  },
  postPaid: {
    true: "پس کرایه",
    false: "پیش کرایه",
  },
};

export const translate = (
  value: any,
  type: dictionaryKeyStrings = "common"
) => {
  return dictionary[type][value];
};

export function flattenObject(obj: { [key: string]: any }) {
  const toReturn = {} as { [key: string]: string };
  for (const i in obj) {
    if (!obj.hasOwnProperty(i) && i !== null) continue;

    if (isArray(obj[i])) {
      // convert Array to string with ','
      obj[i] = obj[i].join(",");
    }
    if (typeof obj[i] == "object" && obj[i] !== null) {
      const flatObject = flattenObject(obj[i]);

      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + "." + x] = flatObject[x];
      }
    } else {
      toReturn[i] = obj[i];
    }
  }
  return toReturn;
}
export const packegeCounter = (packages: object[]) => {
  return packages.reduce((acc, curr) => {
    return acc + curr.count;
  }, 0);
};

export const UserRoles: UserRole[] = [
  "RONAD_ADMIN",
  "MARKETING_MANAGER",
  "MARKETING_EXPERT",
  "OPERATIONS_MANAGER",
  "OPERATIONS_EXPERT",
  "SUPPORT_MANAGER",
  "SUPPORT_EXPERT",
  "WAREHOUSE_SUPERVISOR",
  "WAREHOUSE_ADMIN",
  "WAREHOUSE_OPERATOR",
  "PARTNER_ADMIN",
  "AGENCY_ADMIN",
  "CENTER_ADMIN",
  "SELLER_ADMIN",
  "DRIVER",
  "LOGISTICS_ADMIN",
  "FINANCIAL_SUPERVISOR",
];

export const checkHourisPast = (hour: number, day: string): boolean => {
  if (
    convertPersianDigit2English(jMoment().format("YYYY-MM-DD")) === day ||
    convertPersianDigit2English(jMoment().format("YYYY-MM-DD")) ===
      convertPersianDigit2English(jMoment(day).format("YYYY-MM-DD"))
  ) {
    return convertPersianDigit2English(jMoment().format("HH")) >= hour;
  }
  return false;
};

export const disablePrevDateByHour = (hour: number) => {
  const today = new Date();
  if (today.getHours() >= hour) {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  } else {
    return today;
  }
};

export function convertPersianDigit2English(string: any) {
  return string
    .replace(/[\u0660-\u0669]/g, (c: string) => {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, (c: string) => {
      return c.charCodeAt(0) - 0x06f0;
    });
}

export function convertDatePersianToEnglish(date: any) {
  return date.replace(/[۰-۹]/g, (d: any) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
}

export function numberWithCommas(x: any) {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const removeEmptyValueObject = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (
      // todo: it must be on filter form
      typeof obj[key]?.contains === "string" &&
      obj[key].contains.substring(0, 1) === "0" &&
      key === "phoneNumber"
    ) {
      obj[key].contains = obj[key].contains.replace("0", "98");
    }
    if (obj[key] && typeof obj[key] === "object" && obj[key].length !== 0) {
      removeEmptyValueObject(obj[key]);
    }
    // recurse
    else if (obj[key] == null || obj[key] === "" || obj[key].length === 0)
      delete obj[key]; // delete
  });

  return obj;
};

export function uintToString(uintArray: number[]) {
  const encodedString = String.fromCharCode.apply(null, uintArray),
    decodedString = decodeURIComponent(escape(encodedString));
  return JSON.parse(decodedString);
}

export function formaterPhoneNumber(string: string | undefined) {
  if (string && String(string).includes("+98"))
    return String(string).replace("+98", "0");
  if (string && String(string).includes("+"))
    return String(string).replace("+", "0");
  return string;
}

export function checkMatchMedia(media: string) {
  return window.matchMedia(media).matches;
}

export function fixNumbers(str: string) {
  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];
  for (let i: any = 0; i < 10; i++) {
    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
  }
  return str.trim();
}

export function fixToPersianNumbers(str: string) {
  const englishNumbers = [
      /0/g,
      /1/g,
      /2/g,
      /3/g,
      /4/g,
      /5/g,
      /6/g,
      /7/g,
      /8/g,
      /9/g,
    ],
    persianNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  for (let i: any = 0; i < persianNumbers.length; i++) {
    str = str.replace(englishNumbers[i], persianNumbers[i]);
  }
  return str.trim();
}

export function handleRedirectByRule(role: string) {
  switch (role) {
    case "AGENCY_ADMIN":
      return (window.location.href = "/reports/current-orders");
    case "CENTER_ADMIN":
      return (window.location.href = "/orders");
    case "WAREHOUSE_SUPERVISOR":
      return (window.location.href = "/warehouses");
    case "WAREHOUSE_ADMIN":
      return (window.location.href = "/warehouse-admin-orders");
    case "WAREHOUSE_OPERATOR":
      return (window.location.href = "/parcels-warehouse-operator");
    case "LOGISTICS_ADMIN":
      return (window.location.href = "/nonPost-orders");
    case "SELLER_ADMIN":
      return (window.location.href = "/seller-orders");
    case "EXCHANGE_ADMIN":
      return (window.location.href = "/bundles");
    case "SECURITY_ADMIN":
      return (window.location.href = "/security");
    default:
      return (window.location.href = "/orders");
  }
}

export function useQuery(locationHook: () => any) {
  return new URLSearchParams(locationHook().search);
}

export const handleErrorList = (
  errors: { [s: string]: unknown } | ArrayLike<unknown>
) => {
  const errorList: Array<unknown> = [];
  Object.entries(errors).map((el: Array<unknown>) => {
    // @ts-ignore
    if (el[1].length > 1) {
      // @ts-ignore
      el[1].forEach((item) => {
        errorList.push({ code: el[0], text: item });
      });
    } else {
      // @ts-ignore
      errorList.push({ code: el[0], text: el[1][0] });
    }
  });
  return errorList;
};

export function translateFileUploadErrors(value: string) {
  const errorsList: { [key: string]: string } = {
    "order.customerMobileNumber.invalid": "شماره همراه سفارش‌دهنده اشتباه است",
    "order.customerMobileNumber.invalid.size":
      "شماره همراه سفارش‌دهنده اشتباه است",
    "order.customerPhoneNumber.invalid": "شماره تماس سفارش‌دهنده اشتباه است",
    "order.customerPhoneNumber.invalid.size":
      "شماره تماس سفارش‌دهنده اشتباه است",
    "order.customerAddress.invalid.size": "آدرس سفارش‌دهنده اشتباه است",
    "order.customerAddress.invalid": "آدرس سفارش‌دهنده اشتباه است",
    "order.customerProvince.invalid.size": "استان سفارش‌دهنده اشتباه است",
    "order.customerCity.invalid.size": "شهر سفارش‌دهنده اشتباه است",
    "order.customerZipCode.invalid": "کد پستی سفارش‌دهنده اشتباه است",
    "order.customerZipCode.invalid.size": "کد پستی سفارش‌دهنده اشتباه است",
    "order.customerNationalCode.invalid.size": "کد ملی سفارش‌دهنده اشتباه است",
    "order.customerNationalCode.invalid": "کد ملی سفارش‌دهنده اشتباه است",
    "order.customerName.invalid.size": "نام سفارش‌دهنده اشتباه است",
    "order.trackingCode.invalid.size": "کد پیگیری اشتباه است",
    "order.trackingCode.invalid": "کد پیگیری اشتباه است",
    "order.trackingCode.exists": "کد پیگیری اشتباه است",
    "order.deliveryDate.notExist": "تاریخ تحویل اشتباه است",
    "order.deliveryStartTime.notExist": "ساعت شروع تحویل اشتباه است",
    "order.deliveryEndTime.notExist": "ساعت پایان تحویل اشتباه است",
    "orderItem.productCode.notProvided": "کد کالا اشتباه است",
    "orderItem.productCode.notExists": "کد کالا اشتباه است",
    "orderItem.variantCode.notProvided": "کد تنوع کالای کالا اشتباه است",
    "product.categoryCode.invalid": "کد دسته‌بندی کالا اشتباه است",
    "product.categoryCode.invalid.size": "کد دسته‌بندی کالا اشتباه است",
    "product.name.invalid.size": "نام کلا اشتباه است",
    "product.name.notExist": "نام کلا اشتباه است",
    "product.code.invalid": "کد کلا اشتباه است",
    "product.code.notExist": "کد کلا اشتباه است",
    "product.code.invalid.size": "کد کلا اشتباه است",
    "product.codingType.notExist": "نوع کلا اشتباه است",
    "product.weight.invalid": "وزن کلا اشتباه است",
    "product.length.invalid": "طول کلا اشتباه است",
    "product.width.invalid": "عرض کلا اشتباه است",
    "product.height.invalid": "ارتفاع کلا اشتباه است",
    "product.shippingWeight.invalid": "وزن حمل و نقل کلا اشتباه است",
    "product.shippingLength.invalid": "طول حمل و نقل کلا اشتباه است",
    "product.shippingWidth.invalid": "عرض حمل و نقل کلا اشتباه است",
    "product.shippingHeight.invalid": "ارتفاع حمل و نقل کلا اشتباه است",
    "product.variant.seller.code.invalid": "کد فروشنده کلا اشتباه است",
    "product.variant.seller.code.notExists": "کد فروشنده کلا اشتباه است",
    "product.variant.provider.code.invalid": "کد تامین‌کننده کلا اشتباه است",
    "product.variant.provider.code.notExists": "کد تامین‌کننده کلا اشتباه است",
    "product.variant.code.must.filled": "کد تنوع کالا اشتباه است",
    "orderItem.variantCode.notExists": "کد تنوع کالا اشتباه است",
    "product.code.exist": "این کد کالا قبلا ثبت شده است",
    "product.name.exist": "این نام کالا قبلا ثبت شده است",
    "bundle.deliveryTime.invalid": "بازه ارسال اشتباه است",
    "bundle.deliveryDate.invalid": "تاریخ ارسال اشتباه است",
    "bundle.orderId.notExist": "شناسه سفارش اشتباه است",
    "bundle.driverId.notExist": "شناسه راننده اشتباه است",
  };
  return errorsList[value] ? errorsList[value] : value;
}

export function transformLogo(code: string | number) {
  const logo = {
    LINK_EXPRESS: "/LINK_EXPRESS.png",
    TAROFF: "/TAROFF_V2.png",
    TAROFF_V2: "/TAROFF_V2.png",
    CHAPAR: "/CHAPAR.png",
    SPEED: "/SPEED.png",
    PETROEX: "/PETROEX.png",
    PISHRO_POST: "/PISHRO_POST.png",
    TAPIN_POST: "/TAPIN_POST.svg",
    TAPIN_KETAB: "/TAPIN_KETAB.svg",
    DTSXP: "/DTSXP.png",
    ALOPEYK: "/ALOPEYK.png",
    1: "/TAROFF_V2.png",
    18: "/TAROFF_V2.png",
    2: "/LINK_EXPRESS.png",
    3: "/ALOPEYK.png",
    4: "/CHAPAR.png",
    5: "/PETROEX.png",
    6: "/PISHRO_POST.png",
    7: "/DTSXP.png",
    8: "/SPEED.png",
    9: "/TAPIN_POST.svg",
    10: "/TAPIN_KETAB.svg",
  };

  return logo[code];
}
